<template>
  <v-card>
    <v-card-title>
      <div class="headline">Statistics</div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-title>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.statsTypeDesc }}</td>
        <td class="text-xs-left">{{ props.item.defStatsVal }}</td>
        <td class="text-xs-left">{{ props.item.statUseDesc }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" review @review="doStatsReview" remove @remove="doPromptRemove(props.item)"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click="doNewStatsForm">New Statistics<v-icon>mdi-plus</v-icon></v-btn>
    <v-dialog v-model="reviewStatsMode" max-width="900px" persistent>
      <v-card>
        <v-card-title v-if="newStats">
          <span class="headline">New Statistics</span>
        </v-card-title>
        <v-card-title v-else>
          <span class="headline">Statistics</span>
        </v-card-title>
        <form data-vv-scope = "statsForm">
          <v-card-text>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <v-layout row wrap v-if="newStats">
                <v-flex xs6>
                  <v-autocomplete data-vv-scope = "statsForm" :items="statsTypeList" v-model="statsForm.statsType" :label="labels.statsType" item-text="label" item-value="value" data-vv-name="statsType" :data-vv-as="labels.statsType" :error-messages="errors.collect('statsForm.statsType')" v-validate="'required'" @change="doStatsValList"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete data-vv-scope = "statsForm" :hint="!statsForm.statsType ? 'Please Choose Statistics Type First':''" persistent-hint :items="statsValList" v-model="statsForm.defStatsVal" :label="labels.defStatsVal" item-text="label" item-value="value" data-vv-name="defStatsVal" :data-vv-as="labels.defStatsVal" :error-messages="errors.collect('statsForm.defStatsVal')"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete data-vv-scope = "statsForm" v-model="statsForm.statsUse" :items="statsUseList()" :label="labels.statsUse" item-text="label" item-value="value" :error-messages="errors.collect('statsForm.statsUse')" data-vv-name="statsUse" :data-vv-as="labels.statsUse" v-validate="'required'"></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-else>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.statsType}}</v-subheader>
                  <div class="title">{{statsForm.statsType}} - {{statsForm.statsTypeDesc}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete data-vv-scope = "statsForm" :hint="!statsForm.statsType ? 'Please Choose Statistics Type First':''" :items="statsValList" v-model="statsForm.defStatsVal" :label="labels.defStatsVal" item-text="label" item-value="value" data-vv-name="defStatsVal" :data-vv-as="labels.defStatsVal" :error-messages="errors.collect('statsForm.defStatsVal')"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete data-vv-scope = "statsForm" v-model="statsForm.statsUse" :items="statsUseList()" :label="labels.statsUse" item-text="label" item-value="value" :error-messages="errors.collect('statsForm.statsUse')" data-vv-name="statsUse" :data-vv-as="labels.statsUse" v-validate="'required'"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="doCloseStatsForm">Cancel</v-btn>
            <v-btn color="primary" flat type="submit" :loading="submitting" @click.prevent="doSaveStatsForm">
              {{newStats ? 'Save Statistics' : 'Update Statistics'}}
              <v-icon right>{{newStats ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Business Class Statistic?
        <div class="title">{{deleteBusClsStat}}</div>
      </confirm>
    </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
import { statsUse } from '@/const/underwriting/motor'
export default {
  data() {
    return {
      headers: [
        { text: 'Statistics', value: 'statsTypeDesc' },
        { text: 'Default Statistics Value', value: 'defStatsVal' },
        { text: 'Statistics Use', value: 'statUseDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        statsType: 'Statistics Type',
        defStatsVal: 'Default Statistics Value',
        statsUse: 'Statistics Use'
      },
      statsForm: {
        statsType: null,
        statsTypeDesc: null,
        defStatsVal: null,
        statsUse: null
      },
      newStats: false,
      reviewStatsMode: false,
      statsTypeList: [],
      statsValList: [],
      submitting: false,
      deleteBusClsStat: '',
      promptRemove: false
    }
  },
  computed: {
    busClsMenu() {
      return this.$store.state.parameters.busCls.busClsMenu.menu
    }
  },
  methods: {
    async fetchData(busCls) {
      const apiURI = this.busClsMenu.busClsStatsList
      if (apiURI) {
        try {
          const expand = {
            busCls: busCls
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((statsType) => {
              const convertList = {
                statsType: statsType.statsType,
                statsTypeDesc: statsType.statsType + ' - ' + statsType.statsTypeDesc,
                defStatsVal: statsType.defStatsVal,
                statUseDesc: statsType.statsUse + ' - ' + statsUse[statsType.statsUse],
                statsUse: statsType.statsUse
              }
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.items = []
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    doStatsReview(data) {
      this.statsForm.busCls = this.id
      this.statsForm.statsType = data.item.statsType.split(' ')[0]
      this.statsForm.statsTypeDesc = data.item.statsTypeDesc
      if (data.item.defStatsVal === undefined) {
        this.statsForm.defStatsVal = null
      } else {
        this.statsForm.defStatsVal = data.item.defStatsVal.split(' ')[0]
      }
      this.statsForm.statsUse = data.item.statsUse
      this.doStatsValList(data.item.statsType.split(' ')[0])
      this.reviewStatsMode = true
    },
    async doInitList() {
      await this.statsTypeListInit()
    },
    async statsTypeListInit() {
      const apiURI = this.busClsMenu.statsTypes
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const data = result.data.data
        if (data) {
          if (this.statsTypeList.length > 0) {
            this.statsTypeList = []
          }
          data.map((statsType) => {
            const convertList = {
              label: statsType.statsType + ' - ' + statsType.statsTypeDesc,
              value: statsType.statsType
            }
            this.statsTypeList.push(convertList)
          })
        } else {
          this.statsTypeList = []
        }
      }
    },
    async doStatsValList(statsType) {
      if (statsType != null) {
        const apiURI = this.busClsMenu.statsValues
        if (apiURI) {
          const expand = {
            statsType: statsType
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const data = result.data.data
          if (data) {
            if (this.statsValList.length > 0) {
              this.statsValList = []
            }
            data.map((statsValues) => {
              const convertList = {
                label: statsValues.statsVal + ' - ' + statsValues.statsValDesc,
                value: statsValues.statsVal
              }
              this.statsValList.push(convertList)
            })
          } else {
            this.statsValList = []
          }
        }
      } else {
        this.statsValList = []
      }
    },
    doClearStatsForm() {
      this.statsForm.statsType = null
      this.statsForm.defStatsVal = null
      this.statsForm.statsUse = null
      this.statsValList = []
    },
    doCloseStatsForm() {
      this.resetValidator()
      this.resetMessages()
      this.doClearStatsForm()
      this.reviewStatsMode = false
      this.newStats = false
    },
    doNewStatsForm() {
      this.doClearStatsForm()
      this.newStats = true
      this.reviewStatsMode = true
    },
    async doSaveStatsForm() {
      this.resetMessages()
      this.$validator.validateAll('statsForm').then(result => {
        if (result) {
          if (this.newStats) {
            this.doCreateStats()
          } else {
            this.doUpdateStats()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateStats() {
      const apiURI = this.busClsMenu.busClsStatCreate
      if (apiURI) {
        try {
          const formatForm = {
            busCls: this.id,
            statsType: this.statsForm.statsType,
            defStatsVal: this.statsForm.defStatsVal,
            statsUse: this.statsForm.statsUse
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCloseStatsForm()
            this.fetchData(this.id)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Business Class Statistic Create')
      }
    },
    async doUpdateStats() {
      const apiURI = this.busClsMenu.busClsStatUpdate
      if (apiURI) {
        try {
          const formatForm = {
            busCls: this.id,
            statsType: this.statsForm.statsType,
            defStatsVal: this.statsForm.defStatsVal,
            statsUse: this.statsForm.statsUse
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCloseStatsForm()
            this.fetchData(this.id)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Business Class Statistic Update')
      }
    },
    statsUseList() {
      const list = Object.freeze(statsUse)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: parseInt(key)
        }
      })
      return convertArray
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedBusClsStat = data
        this.deleteBusClsStat = this.id + ' - ' + data.statsTypeDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.parameters.busCls.busClsMenu.menu.busClsStatDelete
      if (apiURI) {
        this.loading = true
        const formatForm = {
          busCls: this.id,
          statsType: this.selectedBusClsStat.statsType,
          defStatsVal: this.selectedBusClsStat.defStatsVal,
          statsUse: this.selectedBusClsStat.statsUse
        }
        try {
          const result = await this.$http.post(apiURI, formatForm)
          this.notify(result.data)
          // Reinit
          this.fetchData(this.id)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Business Class Statistic')
      }
    }
  },
  mounted() {
    Promise.all([this.fetchData(this.id), this.doInitList()])
  },
  props: ['id'],
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
